import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "overview": "Overview",
      "sandbox": "Sandbox",
      "monitoring": "Monitoring",
      "benchmarks": "Benchmarks",
      "security": "Security",
      "api_playground": "API Playground",
      "api_docs": "API Docs",
      
      // Dashboard
      "system_overview": "System Overview",
      "real_time_system_metrics": "Real-time system metrics and status",
      "performance_analytics": "Performance Analytics",
      "historical_system_performance": "Historical system performance data",
      "system_information": "System Information",
      "hardware_environment_details": "Hardware and environment details",
      "real_time_monitoring": "Real-time Monitoring",
      "live_system_metrics": "Live system metrics and performance monitoring",
      
      // Metrics
      "cpu_usage": "CPU Usage",
      "memory_usage": "Memory Usage",
      "disk_usage": "Disk Usage",
      "network_io": "Network I/O",
      "active_processes": "Active Processes",
      "running_processes": "Running processes",
      "outbound_traffic": "Outbound traffic",
      "cpu_usage_over_time": "CPU Usage Over Time",
      "memory_usage_over_time": "Memory Usage Over Time",
      
      // Controls
      "real_time_updates": "Real-time Updates",
      "refresh_data": "Refresh Data",
      "websocket_connection_lost": "WebSocket connection lost. Real-time updates are disabled.",
      "loading_dashboard": "Loading dashboard...",
      "loading_monitoring_data": "Loading monitoring data...",
      
      // Performance
      "performance_metrics": "Performance Metrics",
      "request_count": "Request Count",
      "error_rate": "Error Rate",
      "avg_response_time": "Avg Response Time",
      "throughput": "Throughput",
      "response_time_trend": "Response Time Trend",
      
      // Alerts
      "active_alerts": "Active Alerts",
      "no_active_alerts": "No active alerts",
      "high_cpu_usage": "High CPU Usage",
      
      // Container
      "container_metrics": "Container Metrics",
      "containers": "containers",
      "network_rx": "Network RX",
      "network_tx": "Network TX",
      
      // Units
      "percent": "%",
      "mb_s": "MB/s",
      "ms": "ms",
      "req_s": "req/s",
      "gb_used": "GB used",
      "mb": "MB",
      
      // Common
      "loading": "Loading",
      "error": "Error",
      "success": "Success",
      "warning": "Warning",
      "info": "Info",
      "online": "Online",
      "offline": "Offline",
      "disconnected": "Disconnected",
      "connected": "Connected",
      "healthy": "Healthy",
      "unhealthy": "Unhealthy",
      "refresh": "Refresh",
      "toggle_theme": "Toggle Theme",
      "github_repository": "GitHub Repository",
      
      // Status
      "status": "Status",
      "running": "Running",
      "stopped": "Stopped",
      "pending": "Pending",
      "failed": "Failed",
      
      // Time
      "seconds": "seconds",
      "minutes": "minutes",
      "hours": "hours",
      "days": "days",
      
      // Actions
      "start": "Start",
      "stop": "Stop",
      "restart": "Restart",
      "delete": "Delete",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "submit": "Submit",
      "reset": "Reset",
      "clear": "Clear",
      "search": "Search",
      "filter": "Filter",
      "sort": "Sort",
      "export": "Export",
      "import": "Import",
      "download": "Download",
      "upload": "Upload",
      
      // Messages
      "no_data_available": "No data available",
      "data_loaded_successfully": "Data loaded successfully",
      "operation_completed": "Operation completed",
      "operation_failed": "Operation failed",
      "please_wait": "Please wait",
      "try_again": "Try again",
      
      // Validation
      "required_field": "This field is required",
      "invalid_format": "Invalid format",
      "value_too_small": "Value is too small",
      "value_too_large": "Value is too large",
      
      // Additional
      "is_at": "is at",
      
      // Sandbox
      "code_sandbox": "Code Sandbox",
      "interactive_code_execution": "Interactive code execution environment",
      "language": "Language",
      "environment": "Environment",
      "run_code": "Run Code",
      "stop_execution": "Stop Execution",
      "clear_output": "Clear Output",
      "copy_output": "Copy Output",
      "download_output": "Download Output",
      "enter_code_here": "Enter your code here...",
      "output": "Output",
      "execution_settings": "Execution Settings",
      "code_examples": "Code Examples",
      "python_example": "Python Example",
      "javascript_example": "JavaScript Example", 
      "bash_example": "Bash Example",
      "load_example": "Load Example",
      "execution_time": "Execution Time",
      "memory_usage_mb": "Memory Usage (MB)",
      "exit_code": "Exit Code",
      "running_code": "Running...",
      "completed": "Completed",
      "failed_execution": "Failed",
      "timeout": "Timeout",
      "code_copied": "Code copied to clipboard!",
      "output_downloaded": "Output downloaded successfully!",
      
      // Settings
      "settings": "Settings",
      "refresh_interval": "Refresh Interval",
      "enable_notifications": "Enable notifications",
      "sound_notifications": "Sound notifications",
      "show_system_alerts": "Show system alerts and status notifications",
      "build_environment": "Build Environment",
      "production": "Production",
      "websocket_status": "WebSocket Status",
      "websocket_connected": "Connected",
      
      // API Documentation
      "api_documentation": "API Documentation",
      "explore_test_endpoints": "Explore and test all available REST endpoints",
      "available": "Available",
      "websocket_documentation": "WebSocket Documentation",
      "realtime_websocket_docs": "Real-time WebSocket connection documentation",
      "live": "Live",
      "rest_endpoints": "REST Endpoints",
      "websocket_events": "WebSocket Events",
      "get_health_check": "Get system health status",
      "get_dashboard_metrics": "Get dashboard metrics",
      "get_system_metrics": "Get detailed system metrics",
      "get_sandbox_status": "Get sandbox environment status",
      "execute_code": "Execute code in sandbox",
      "run_load_test": "Run performance load test",
      "security_scan": "Run security vulnerability scan",
      
      // Dashboard
      "dashboard_overview": "Overview",
      "advanced_analytics": "Advanced Analytics",
      "sandbox_status": "Sandbox Status",
      "active": "active",
      
      // Benchmarks
      "test_name": "Test Name",
      "concurrent_users": "Concurrent Users",
      "duration": "Duration",
      "target_url": "Target URL",
      "request_method": "Request Method",
      "headers": "Headers",
      "body": "Body",
      "run_test": "Run Test",
      "stop_test": "Stop Test",
      "test_results": "Test Results",
      "total_requests": "Total Requests",
      "successful_requests": "Successful Requests",
      "failed_requests": "Failed Requests",
      "average_response_time": "Average Response Time",
      "min_response_time": "Min Response Time",
      "max_response_time": "Max Response Time",
      "requests_per_second": "Requests per Second",
      "quick_test": "Quick Test",
      
      // Security
      "security_score": "Security Score",
      "critical_issues": "Critical Issues",
      "high_priority": "High Priority",
      "total_issues": "Total Issues",
      "good": "Good",
      "secure": "Secure",
      "security_warning": "Warning",
      "monitor": "Monitor",
      
      // API Playground
      "method": "Method",
      "api_headers": "Headers",
      "api_body": "Body",
      "headers_json": "Headers (JSON)",
      "headers_placeholder": '{"Authorization": "Bearer token", "Content-Type": "application/json"}',
      
      // Settings
      "auto_refresh": "Auto Refresh",
      "theme_settings": "Theme Settings",
      "notification_settings": "Notification Settings",
      "system_info": "System Information",
      "app_version": "App Version",
      "build_date": "Build Date",
      "node_version": "Node Version",
      "enable_sound": "Enable Sound",
      "notification_volume": "Notification Volume",
      "show_desktop_notifications": "Show Desktop Notifications",
      
      // Common UI Elements
      "send_request": "Send Request",
      "clear_response": "Clear Response",
      "copy_response": "Copy Response",
      "response": "Response",
      "request": "Request",
      "endpoint": "Endpoint",
      "parameters": "Parameters",
      "authentication": "Authentication",
      "documentation": "Documentation",
      "examples": "Examples",
      "try_it_out": "Try it out",
      
      // File Operations
      "creating_temporary_files": "Creating temporary files...",
      "hello_world": "Hello World",
      "file_content": "File content",
      "current_processes": "Current processes",
      
      // Font Family (for code)
      "monospace_fonts": "Monaco, Consolas, \"Courier New\", monospace",
      
      // Dashboard Cards
      "hardware": "Hardware",
      "dashboard_environment": "Environment",
      "quick_actions": "Quick Actions",
      "cpu_cores": "CPU Cores",
      "total_memory": "Total Memory",
      "disk_space": "Disk Space",
      "platform": "Platform",
      "python_version": "Python Version",
      "websocket": "WebSocket",
      "open_sandbox": "Open Sandbox",
      "view_monitoring": "View Monitoring",
      "dashboard_security_scan": "Security Scan",
      
      // Environment Info
      "environment_info": "Environment Info",
      "standard_development_environment": "Standard development environment",
      "supported_languages": "Supported Languages",
      "memory_limit": "Memory Limit",
      "cpu_limit": "CPU Limit",
      "sandbox_timeout": "Timeout",
      "sandbox_status_label": "Status",
      "active_executions": "Active Executions",
      "total_executions": "Total Executions",
      "output_will_appear": "Output will appear here after code execution",
      
      // Performance
      "dashboard_network_rx": "Network RX",
      "dashboard_network_tx": "Network TX",
      "performance_summary": "Performance Summary",
      "total_tests": "Total Tests",
      "dashboard_error_rate": "Error Rate",
      "avg_response": "Avg Response",
      
      // Benchmark Suites
      "benchmark_suites": "Benchmark Suites",
      "test_core_api_performance": "Test core API endpoints performance",
      "stress_test_system": "Stress test system under heavy load",
      "long_running_tests": "Long-running tests for stability and memory leaks",
      
      // Security
      "security_status": "Security Status",
      "overall_security_score": "Overall Security Score",
      "last_security_scan": "Last security scan",
      "vulnerability_breakdown": "Vulnerability Breakdown",
      "security_actions": "Security Actions",
      "no_critical_vulnerabilities": "No critical vulnerabilities detected. System security is within acceptable parameters.",
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "run_security_scan": "Run Security Scan",
      "update_security_policies": "Update Security Policies",
      "view_security_report": "View Security Report",
      "vulnerability_assessment": "Vulnerability Assessment",
      
      // API Playground
      "dashboard_api_playground": "API Playground",
      "interactive_api_testing": "Interactive API testing and documentation",
      "available_endpoints": "Available Endpoints",
      "request_builder": "Request Builder",
      "url": "URL",
      "send": "Send",
      "sending": "Sending...",
      "header": "HEADER",
      "system_health_check": "System health check",
      "system_statistics": "System statistics",
      "sandbox_status_desc": "Sandbox status",
      "available_environments": "Available environments",
      "execute_code_desc": "Execute code",
      "system_metrics_desc": "System metrics",
      
      // API Documentation
      "openapi_docs": "OpenAPI Docs",
      "redoc_documentation": "ReDoc Documentation",
      "rest_api": "REST API",
      "websocket_api": "WebSocket API",
      "openapi_spec": "OpenAPI Spec",
      "api_endpoints": "API Endpoints",
      "health_check_endpoint": "Health check endpoint",
      "system_metrics_dashboard": "System metrics dashboard",
      "dashboard_real_time_system_metrics": "Real-time system metrics",
      "sandbox_environment_status": "Sandbox environment status",
      "execute_code_in_sandbox": "Execute code in sandbox",
      "start_load_testing": "Start load testing",
      "security_vulnerability_scan": "Security vulnerability scan",
      "websocket_real_time": "WebSocket real-time connection",
      "download_openapi_spec": "Download OpenAPI specification",
      
      // Common Status
      "dashboard_running": "running",
      "hours_ago": "hours ago",
      "real_time_monitoring_active": "Real-time monitoring active",
      "real_time_monitoring_disconnected": "Real-time monitoring disconnected",
      
      // HTTP Methods
      "get": "GET",
      "post": "POST",
      "put": "PUT",
      "http_delete": "DELETE",
      
      // Advanced Dashboard
      "sent": "Sent",
      "received": "Received",
      "refresh_dashboard": "Refresh Dashboard",
      "cpu": "CPU",
      "memory": "Memory",
      "disk": "Disk",
      "system_health_overview": "System Health Overview",
      "dashboard_real_time_updates": "Real-time Updates",
      
      // Additional Settings
      "auto_refresh_data": "Auto-refresh data",
      "auto_refresh_description": "Automatically refresh system metrics and monitoring data",
      
      // API Playground Additional
      "request_body_json": "Request Body (JSON)",
      
      // Settings Notifications
      "settings_saved": "Settings Saved",
      "preferences_updated_successfully": "Your preferences have been updated successfully",
      "settings_imported": "Settings Imported",
      "settings_imported_successfully": "Settings have been imported successfully",
      "import_failed": "Import Failed",
      "invalid_settings_file_format": "Invalid settings file format",
      "cache_cleared": "Cache Cleared",
      "local_storage_cleared": "Local storage has been cleared",
      
      // Dashboard Messages
      "failed_to_load_dashboard_data": "Failed to load dashboard data",
      "normal": "Normal",
      
      // Sandbox Messages
      "code_executed_successfully_no_output": "Code executed successfully (no output)",
      "execution_failed": "Execution failed",
      
      // Programming Languages
      "python": "Python",
      "javascript": "JavaScript",
      "bash": "Bash",
      
      // API Playground Response
      "response_headers": "Response Headers",
      "response_body": "Response Body",
      
      // Benchmarks Dialog
      "configure_load_test": "Configure Load Test",
      "starting": "Starting...",
      "start_test": "Start Test",
      
      // Loading Messages
      "loading_security_data": "Loading security data...",
      
      // App Error Messages
      "failed_to_connect_to_backend": "Failed to connect to backend services",
      
      // API Error Messages
      "an_error_occurred": "An error occurred",
      "code_cannot_be_empty": "Code cannot be empty",
      "language_must_be_specified": "Language must be specified",
      "timeout_must_be_between": "Timeout must be between 1 and 300 seconds",
      "target_url_required": "Target URL is required",
      "concurrent_users_range": "Concurrent users must be between 1 and 100",
      "duration_range": "Duration must be between 10 and 300 seconds",
      
      // File Size Units
      "bytes": "Bytes",
      "zero_bytes": "0 Bytes",
      
      
      // API Info
      "devsandbox_pro_api": "DevSandbox Pro API",
      "api_description": "A production-ready containerized development sandbox API",
      "invalid_json_headers": "Invalid JSON in headers",
      "invalid_json_request_body": "Invalid JSON in request body",
      
      // Additional UI Elements
      "clear_cache": "Clear Cache",
      "reload_application": "Reload Application",
      "advanced_dashboard": "Advanced Dashboard",
      "reset_to_default": "Reset to Default",
      "version_3_0": "v3.0",
      "websocket_short": "WS",
      
      // Benchmarks
      "performance_benchmarks": "Performance Benchmarks",
      "load_testing_performance_analysis": "Load testing and performance analysis tools",
      "start_load_test": "Start Load Test",
      "test_api": "Test API",
      "api_performance": "API Performance",
      "stress_test": "Stress Test",
      "endurance_test": "Endurance Test",
      "recommendations": "Recommendations",
      "no_performance_data_available": "No performance data available yet. Run some load tests to see results here.",
      "tests_completed_refresh_message": "{{count}} test(s) completed! Click \"Refresh Data\" to update performance metrics.",
      
      // Security Alert Messages
      "security_scan_initiated": "Security scan initiated!",
      "security_policies_updated": "Security policies updated!",
      "generating_security_report": "Generating security report...",
      
      // API Playground
      "json_placeholder": "{\"key\": \"value\"}",
      
      // Missing UI Elements
      "completed_tests_count": "Completed Tests ({{count}})",
      "containerized_development_environment": "Containerized Development Environment",
      
      // Dynamic Test Status Messages
      "load_tests_running": "{{count}} load test(s) running: {{names}}",
      "benchmark_suites_running": "{{count}} benchmark suite(s) running: {{names}}",
      "api_tests_running": "{{count}} API test(s) running: {{names}}",
      "legacy_tests_running": "{{count}} legacy test(s) running...",
      
      // API Documentation Extended
      "openapi_docs_swagger": "OpenAPI Docs (Swagger)",
      "api_comprehensive_description": "The DevSandbox Pro API provides comprehensive endpoints for sandbox management, system monitoring, performance benchmarking, and real-time metrics collection. Use the interactive documentation links above for detailed API specifications."
    }
  },
  de: {
    translation: {
      // Navigation
      "overview": "Übersicht",
      "sandbox": "Sandbox",
      "monitoring": "Überwachung",
      "benchmarks": "Benchmarks",
      "security": "Sicherheit",
      "api_playground": "API Playground",
      "api_docs": "API Dokumentation",
      
      // Dashboard
      "system_overview": "Systemübersicht",
      "real_time_system_metrics": "Echtzeit-Systemmetriken und Status",
      "performance_analytics": "Leistungsanalyse",
      "historical_system_performance": "Historische Systemleistungsdaten",
      "system_information": "Systeminformationen",
      "hardware_environment_details": "Hardware- und Umgebungsdetails",
      "real_time_monitoring": "Echtzeit-Überwachung",
      "live_system_metrics": "Live-Systemmetriken und Leistungsüberwachung",
      
      // Metrics
      "cpu_usage": "CPU-Auslastung",
      "memory_usage": "Speicherverbrauch",
      "disk_usage": "Festplattennutzung",
      "network_io": "Netzwerk-E/A",
      "active_processes": "Aktive Prozesse",
      "running_processes": "Laufende Prozesse",
      "outbound_traffic": "Ausgehender Datenverkehr",
      "cpu_usage_over_time": "CPU-Auslastung über Zeit",
      "memory_usage_over_time": "Speicherverbrauch über Zeit",
      
      // Controls
      "real_time_updates": "Echtzeit-Updates",
      "refresh_data": "Daten aktualisieren",
      "websocket_connection_lost": "WebSocket-Verbindung verloren. Echtzeit-Updates sind deaktiviert.",
      "loading_dashboard": "Dashboard wird geladen...",
      "loading_monitoring_data": "Überwachungsdaten werden geladen...",
      
      // Performance
      "performance_metrics": "Leistungsmetriken",
      "request_count": "Anfragenzahl",
      "error_rate": "Fehlerrate",
      "avg_response_time": "Durchschn. Antwortzeit",
      "throughput": "Durchsatz",
      "response_time_trend": "Antwortzeit-Trend",
      
      // Alerts
      "active_alerts": "Aktive Warnungen",
      "no_active_alerts": "Keine aktiven Warnungen",
      "high_cpu_usage": "Hohe CPU-Auslastung",
      
      // Container
      "container_metrics": "Container-Metriken",
      "containers": "Container",
      "network_rx": "Netzwerk RX",
      "network_tx": "Netzwerk TX",
      
      // Units
      "percent": "%",
      "mb_s": "MB/s",
      "ms": "ms",
      "req_s": "Anf/s",
      "gb_used": "GB verwendet",
      "mb": "MB",
      
      // Common
      "loading": "Wird geladen",
      "error": "Fehler",
      "success": "Erfolg",
      "warning": "Warnung",
      "info": "Info",
      "online": "Online",
      "offline": "Offline",
      "disconnected": "Getrennt",
      "connected": "Verbunden",
      "healthy": "Gesund",
      "unhealthy": "Ungesund",
      "refresh": "Aktualisieren",
      "toggle_theme": "Theme wechseln",
      "github_repository": "GitHub Repository",
      
      // Status
      "status": "Status",
      "running": "Läuft",
      "stopped": "Gestoppt",
      "pending": "Ausstehend",
      "failed": "Fehlgeschlagen",
      
      // Time
      "seconds": "Sekunden",
      "minutes": "Minuten",
      "hours": "Stunden",
      "days": "Tage",
      
      // Actions
      "start": "Starten",
      "stop": "Stoppen",
      "restart": "Neustarten",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "submit": "Senden",
      "reset": "Zurücksetzen",
      "clear": "Löschen",
      "search": "Suchen",
      "filter": "Filtern",
      "sort": "Sortieren",
      "export": "Exportieren",
      "import": "Importieren",
      "download": "Herunterladen",
      "upload": "Hochladen",
      
      // Messages
      "no_data_available": "Keine Daten verfügbar",
      "data_loaded_successfully": "Daten erfolgreich geladen",
      "operation_completed": "Vorgang abgeschlossen",
      "operation_failed": "Vorgang fehlgeschlagen",
      "please_wait": "Bitte warten",
      "try_again": "Erneut versuchen",
      
      // Validation
      "required_field": "Dieses Feld ist erforderlich",
      "invalid_format": "Ungültiges Format",
      "value_too_small": "Wert ist zu klein",
      "value_too_large": "Wert ist zu groß",
      
      // Additional
      "is_at": "liegt bei",
      
      // Sandbox
      "code_sandbox": "Code-Sandbox",
      "interactive_code_execution": "Interaktive Code-Ausführungsumgebung",
      "language": "Sprache",
      "environment": "Umgebung",
      "run_code": "Code ausführen",
      "stop_execution": "Ausführung stoppen",
      "clear_output": "Ausgabe löschen",
      "copy_output": "Ausgabe kopieren",
      "download_output": "Ausgabe herunterladen",
      "enter_code_here": "Geben Sie hier Ihren Code ein...",
      "output": "Ausgabe",
      "execution_settings": "Ausführungseinstellungen",
      "code_examples": "Code-Beispiele",
      "python_example": "Python-Beispiel",
      "javascript_example": "JavaScript-Beispiel",
      "bash_example": "Bash-Beispiel", 
      "load_example": "Beispiel laden",
      "execution_time": "Ausführungszeit",
      "memory_usage_mb": "Speicherverbrauch (MB)",
      "exit_code": "Exit-Code",
      "running_code": "Läuft...",
      "completed": "Abgeschlossen",
      "failed_execution": "Fehlgeschlagen",
      "timeout": "Zeitüberschreitung",
      "code_copied": "Code in die Zwischenablage kopiert!",
      "output_downloaded": "Ausgabe erfolgreich heruntergeladen!",
      
      // Settings
      "settings": "Einstellungen",
      "refresh_interval": "Aktualisierungsintervall",
      "enable_notifications": "Benachrichtigungen aktivieren",
      "sound_notifications": "Ton-Benachrichtigungen",
      "show_system_alerts": "Systemwarnungen und Statusbenachrichtigungen anzeigen",
      "build_environment": "Build-Umgebung",
      "production": "Produktion",
      "websocket_status": "WebSocket-Status",
      "websocket_connected": "Verbunden",
      
      // API Documentation
      "api_documentation": "API-Dokumentation",
      "explore_test_endpoints": "Alle verfügbaren REST-Endpunkte erkunden und testen",
      "available": "Verfügbar",
      "websocket_documentation": "WebSocket-Dokumentation",
      "realtime_websocket_docs": "Echtzeit-WebSocket-Verbindungsdokumentation",
      "live": "Live",
      "rest_endpoints": "REST-Endpunkte",
      "websocket_events": "WebSocket-Ereignisse",
      "get_health_check": "System-Gesundheitsstatus abrufen",
      "get_dashboard_metrics": "Dashboard-Metriken abrufen",
      "get_system_metrics": "Detaillierte Systemmetriken abrufen",
      "get_sandbox_status": "Sandbox-Umgebungsstatus abrufen",
      "execute_code": "Code in Sandbox ausführen",
      "run_load_test": "Leistungs-Lasttest ausführen",
      "security_scan": "Sicherheitsschwachstellen-Scan ausführen",
      
      // Dashboard
      "dashboard_overview": "Übersicht",
      "advanced_analytics": "Erweiterte Analysen",
      "sandbox_status": "Sandbox-Status",
      "active": "aktiv",
      
      // Benchmarks
      "test_name": "Testname",
      "concurrent_users": "Gleichzeitige Benutzer",
      "duration": "Dauer",
      "target_url": "Ziel-URL",
      "request_method": "Anfrage-Methode",
      "headers": "Header",
      "body": "Body",
      "run_test": "Test ausführen",
      "stop_test": "Test stoppen",
      "test_results": "Testergebnisse",
      "total_requests": "Gesamtanfragen",
      "successful_requests": "Erfolgreiche Anfragen",
      "failed_requests": "Fehlgeschlagene Anfragen",
      "average_response_time": "Durchschnittliche Antwortzeit",
      "min_response_time": "Min. Antwortzeit",
      "max_response_time": "Max. Antwortzeit",
      "requests_per_second": "Anfragen pro Sekunde",
      "quick_test": "Schnelltest",
      
      // Security
      "security_score": "Sicherheitsbewertung",
      "critical_issues": "Kritische Probleme",
      "high_priority": "Hohe Priorität",
      "total_issues": "Gesamtprobleme",
      "good": "Gut",
      "secure": "Sicher",
      "security_warning": "Warnung",
      "monitor": "Überwachen",
      
      // API Playground
      "method": "Methode",
      "api_headers": "Header",
      "api_body": "Body",
      "headers_json": "Header (JSON)",
      "headers_placeholder": '{"Authorization": "Bearer token", "Content-Type": "application/json"}',
      
      // Settings
      "auto_refresh": "Automatische Aktualisierung",
      "theme_settings": "Theme-Einstellungen",
      "notification_settings": "Benachrichtigungseinstellungen",
      "system_info": "Systeminformationen",
      "app_version": "App-Version",
      "build_date": "Build-Datum",
      "node_version": "Node-Version",
      "enable_sound": "Ton aktivieren",
      "notification_volume": "Benachrichtigungslautstärke",
      "show_desktop_notifications": "Desktop-Benachrichtigungen anzeigen",
      
      // Common UI Elements
      "send_request": "Anfrage senden",
      "clear_response": "Antwort löschen",
      "copy_response": "Antwort kopieren",
      "response": "Antwort",
      "request": "Anfrage",
      "endpoint": "Endpunkt",
      "parameters": "Parameter",
      "authentication": "Authentifizierung",
      "documentation": "Dokumentation",
      "examples": "Beispiele",
      "try_it_out": "Ausprobieren",
      
      // File Operations
      "creating_temporary_files": "Erstelle temporäre Dateien...",
      "hello_world": "Hallo Welt",
      "file_content": "Dateiinhalt",
      "current_processes": "Aktuelle Prozesse",
      
      // Font Family (for code)
      "monospace_fonts": "Monaco, Consolas, \"Courier New\", monospace",
      
      // Dashboard Cards
      "hardware": "Hardware",
      "dashboard_environment": "Umgebung",
      "quick_actions": "Schnellaktionen",
      "cpu_cores": "CPU-Kerne",
      "total_memory": "Gesamtspeicher",
      "disk_space": "Festplattenspeicher",
      "platform": "Plattform",
      "python_version": "Python-Version",
      "websocket": "WebSocket",
      "open_sandbox": "Sandbox öffnen",
      "view_monitoring": "Überwachung anzeigen",
      "dashboard_security_scan": "Sicherheitsscan",
      
      // Environment Info
      "environment_info": "Umgebungsinfo",
      "standard_development_environment": "Standard-Entwicklungsumgebung",
      "supported_languages": "Unterstützte Sprachen",
      "memory_limit": "Speicherlimit",
      "cpu_limit": "CPU-Limit",
      "sandbox_timeout": "Zeitüberschreitung",
      "sandbox_status_label": "Status",
      "active_executions": "Aktive Ausführungen",
      "total_executions": "Gesamtausführungen",
      "output_will_appear": "Ausgabe wird hier nach der Code-Ausführung angezeigt",
      
      // Performance
      "dashboard_network_rx": "Netzwerk RX",
      "dashboard_network_tx": "Netzwerk TX",
      "performance_summary": "Leistungsübersicht",
      "total_tests": "Gesamttests",
      "dashboard_error_rate": "Fehlerrate",
      "avg_response": "Durchschn. Antwort",
      
      // Benchmark Suites
      "benchmark_suites": "Benchmark-Suites",
      "test_core_api_performance": "Kern-API-Endpunkt-Leistung testen",
      "stress_test_system": "System unter hoher Last testen",
      "long_running_tests": "Langzeittests für Stabilität und Speicherlecks",
      
      // Security
      "security_status": "Sicherheitsstatus",
      "overall_security_score": "Gesamtsicherheitsbewertung",
      "last_security_scan": "Letzter Sicherheitsscan",
      "vulnerability_breakdown": "Schwachstellen-Aufschlüsselung",
      "security_actions": "Sicherheitsaktionen",
      "no_critical_vulnerabilities": "Keine kritischen Schwachstellen erkannt. Systemsicherheit liegt innerhalb akzeptabler Parameter.",
      "critical": "Kritisch",
      "high": "Hoch",
      "medium": "Mittel",
      "low": "Niedrig",
      "run_security_scan": "Sicherheitsscan ausführen",
      "update_security_policies": "Sicherheitsrichtlinien aktualisieren",
      "view_security_report": "Sicherheitsbericht anzeigen",
      "vulnerability_assessment": "Schwachstellenbewertung",
      
      // API Playground
      "dashboard_api_playground": "API-Spielplatz",
      "interactive_api_testing": "Interaktive API-Tests und Dokumentation",
      "available_endpoints": "Verfügbare Endpunkte",
      "request_builder": "Anfrage-Builder",
      "url": "URL",
      "send": "Senden",
      "sending": "Sende...",
      "header": "HEADER",
      "system_health_check": "System-Gesundheitscheck",
      "system_statistics": "Systemstatistiken",
      "sandbox_status_desc": "Sandbox-Status",
      "available_environments": "Verfügbare Umgebungen",
      "execute_code_desc": "Code ausführen",
      "system_metrics_desc": "Systemmetriken",
      
      // API Documentation
      "openapi_docs": "OpenAPI-Docs",
      "redoc_documentation": "ReDoc-Dokumentation",
      "rest_api": "REST-API",
      "websocket_api": "WebSocket-API",
      "openapi_spec": "OpenAPI-Spezifikation",
      "api_endpoints": "API-Endpunkte",
      "health_check_endpoint": "Gesundheitscheck-Endpunkt",
      "system_metrics_dashboard": "Systemmetriken-Dashboard",
      "dashboard_real_time_system_metrics": "Echtzeit-Systemmetriken",
      "sandbox_environment_status": "Sandbox-Umgebungsstatus",
      "execute_code_in_sandbox": "Code in Sandbox ausführen",
      "start_load_testing": "Lasttest starten",
      "security_vulnerability_scan": "Sicherheitsschwachstellen-Scan",
      "websocket_real_time": "WebSocket-Echtzeitverbindung",
      "download_openapi_spec": "OpenAPI-Spezifikation herunterladen",
      
      // Common Status
      "dashboard_running": "läuft",
      "hours_ago": "Stunden her",
      "real_time_monitoring_active": "Echtzeit-Überwachung aktiv",
      "real_time_monitoring_disconnected": "Echtzeit-Überwachung getrennt",
      
      // HTTP Methods
      "get": "GET",
      "post": "POST",
      "put": "PUT",
      "http_delete": "DELETE",
      
      // Advanced Dashboard
      "sent": "Gesendet",
      "received": "Empfangen",
      "refresh_dashboard": "Dashboard aktualisieren",
      "cpu": "CPU",
      "memory": "Speicher",
      "disk": "Festplatte",
      "system_health_overview": "System-Gesundheitsübersicht",
      "dashboard_real_time_updates": "Echtzeit-Updates",
      
      // Additional Settings
      "auto_refresh_data": "Daten automatisch aktualisieren",
      "auto_refresh_description": "Systemmetriken und Überwachungsdaten automatisch aktualisieren",
      
      // API Playground Additional
      "request_body_json": "Anfrage-Body (JSON)",
      
      // Settings Notifications
      "settings_saved": "Einstellungen gespeichert",
      "preferences_updated_successfully": "Ihre Einstellungen wurden erfolgreich aktualisiert",
      "settings_imported": "Einstellungen importiert",
      "settings_imported_successfully": "Einstellungen wurden erfolgreich importiert",
      "import_failed": "Import fehlgeschlagen",
      "invalid_settings_file_format": "Ungültiges Einstellungsdateiformat",
      "cache_cleared": "Cache geleert",
      "local_storage_cleared": "Lokaler Speicher wurde geleert",
      
      // Dashboard Messages
      "failed_to_load_dashboard_data": "Dashboard-Daten konnten nicht geladen werden",
      "normal": "Normal",
      
      // Sandbox Messages
      "code_executed_successfully_no_output": "Code erfolgreich ausgeführt (keine Ausgabe)",
      "execution_failed": "Ausführung fehlgeschlagen",
      
      // Programming Languages
      "python": "Python",
      "javascript": "JavaScript",
      "bash": "Bash",
      
      // API Playground Response
      "response_headers": "Antwort-Header",
      "response_body": "Antwort-Body",
      
      // Benchmarks Dialog
      "configure_load_test": "Lasttest konfigurieren",
      "starting": "Startet...",
      "start_test": "Test starten",
      
      // Loading Messages
      "loading_security_data": "Lade Sicherheitsdaten...",
      
      // App Error Messages
      "failed_to_connect_to_backend": "Verbindung zu Backend-Diensten fehlgeschlagen",
      
      // API Error Messages
      "an_error_occurred": "Ein Fehler ist aufgetreten",
      "code_cannot_be_empty": "Code darf nicht leer sein",
      "language_must_be_specified": "Sprache muss angegeben werden",
      "timeout_must_be_between": "Timeout muss zwischen 1 und 300 Sekunden liegen",
      "target_url_required": "Ziel-URL ist erforderlich",
      "concurrent_users_range": "Gleichzeitige Benutzer müssen zwischen 1 und 100 liegen",
      "duration_range": "Dauer muss zwischen 10 und 300 Sekunden liegen",
      
      // File Size Units
      "bytes": "Bytes",
      "zero_bytes": "0 Bytes",
      
      
      // API Info
      "devsandbox_pro_api": "DevSandbox Pro API",
      "api_description": "Eine produktionsreife containerisierte Entwicklungs-Sandbox-API",
      "invalid_json_headers": "Ungültiges JSON in Headern",
      "invalid_json_request_body": "Ungültiges JSON im Anfrage-Body",
      
      // Additional UI Elements
      "clear_cache": "Cache leeren",
      "reload_application": "Anwendung neu laden",
      "advanced_dashboard": "Erweiterte Übersicht",
      "reset_to_default": "Auf Standard zurücksetzen",
      "version_3_0": "v3.0",
      "websocket_short": "WS",
      
      // Benchmarks
      "performance_benchmarks": "Leistungs-Benchmarks",
      "load_testing_performance_analysis": "Lasttest- und Leistungsanalyse-Tools",
      "start_load_test": "Lasttest starten",
      "test_api": "API testen",
      "api_performance": "API-Leistung",
      "stress_test": "Stresstest",
      "endurance_test": "Ausdauertest",
      "recommendations": "Empfehlungen",
      "no_performance_data_available": "Noch keine Leistungsdaten verfügbar. Führen Sie einige Lasttests aus, um hier Ergebnisse zu sehen.",
      "tests_completed_refresh_message": "{{count}} Test(s) abgeschlossen! Klicken Sie auf \"Daten aktualisieren\", um die Leistungsmetriken zu aktualisieren.",
      
      // Security Alert Messages
      "security_scan_initiated": "Sicherheitsscan gestartet!",
      "security_policies_updated": "Sicherheitsrichtlinien aktualisiert!",
      "generating_security_report": "Sicherheitsbericht wird erstellt...",
      
      // API Playground
      "json_placeholder": "{\"schlüssel\": \"wert\"}",
      
      // Missing UI Elements
      "completed_tests_count": "Abgeschlossene Tests ({{count}})",
      "containerized_development_environment": "Containerisierte Entwicklungsumgebung",
      
      // Dynamic Test Status Messages
      "load_tests_running": "{{count}} Lasttest(s) läuft: {{names}}",
      "benchmark_suites_running": "{{count}} Benchmark-Suite(s) läuft: {{names}}",
      "api_tests_running": "{{count}} API-Test(s) läuft: {{names}}",
      "legacy_tests_running": "{{count}} Legacy-Test(s) läuft...",
      
      // API Documentation Extended
      "openapi_docs_swagger": "OpenAPI-Docs (Swagger)",
      "api_comprehensive_description": "Die DevSandbox Pro API bietet umfassende Endpunkte für Sandbox-Management, Systemüberwachung, Leistungs-Benchmarking und Echtzeit-Metriken-Sammlung. Verwenden Sie die interaktiven Dokumentationslinks oben für detaillierte API-Spezifikationen."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Default language is German
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Store language preference in localStorage
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
